import { render, staticRenderFns } from "./MyGbsModal.vue?vue&type=template&id=218a49fc&scoped=true&"
import script from "./MyGbsModal.vue?vue&type=script&lang=js&"
export * from "./MyGbsModal.vue?vue&type=script&lang=js&"
import style0 from "./MyGbsModal.vue?vue&type=style&index=0&id=218a49fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218a49fc",
  null
  
)

export default component.exports